import styled, { css } from 'styled-components';
import { ReactComponent as TrashIcon } from 'assets/icons/ic_trash.svg';

// Import styles
import { transitionMain, customMinResponsive } from 'components/styles';

export const Root = styled.div`
	width: calc(100% - 8rem);
	margin: 0 auto;
	margin-bottom: 3.5rem;
`;

export const SliderContainer = styled.div`
	.slick-track {
		margin-left: 0;
	}
`;

export const Wrapper = styled.span`
	background: ${({ theme }) => `${theme.recordings.deviceTileBg}`};
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: space-between;
	position: relative;

	${({ backgroundImageUrl }) =>
		backgroundImageUrl &&
		css`
			background: url(${backgroundImageUrl}) no-repeat center center;
			background-size: cover;
			align-items: flex-end;
		`}
`;

export const Item = styled.span`
	padding: 0.6rem;
	max-width: 90%;

	${customMinResponsive(
		993,
		css`
			padding: 1rem;
		`
	)}

	${customMinResponsive(
		1700,
		css`
			padding: 1.4rem;
		`
	)}
`;

export const Info = styled.p`
	display: block;
	color: ${({ theme }) => `${theme.white}`};
	font-size: 1.2rem;
	line-height: 1.3;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	${customMinResponsive(
		993,
		css`
			font-size: 1.4rem;
		`
	)}

	${customMinResponsive(
		1700,
		css`
			font-size: 1.6rem;
			line-height: 1.2;
		`
	)}
`;

export const SliderItem = styled.div`
	height: calc((900px / ${({ itemsToShow }) => itemsToShow}) * 0.6);

	${customMinResponsive(
		900,
		css`
			height: calc((100vw / ${({ itemsToShow }) => itemsToShow}) * 0.6);
		`
	)}
`;

export const Content = styled.div`
	position: relative;
	height: 100%;
	padding: 0.3rem;
`;

export const TrashIconStyled = styled(TrashIcon)`
	width: 1.9rem;
	height: 2.5rem;

	path {
		fill: ${({ theme: { user } }) => user.removeIcon};
		stroke: ${({ theme: { user } }) => user.removeIcon};
		${transitionMain};
	}
`;

export const DeleteButton = styled.button`
	width: 2.9rem;
	height: 3rem;
	cursor: pointer;
	background: transparent;
	border: inherit;
	outline: none;
	align-self: flex-start;
	margin-top: 0.5rem;
	margin-right: 0.3rem;
	position: absolute;
	top: 0;
	right: 0;

	&:focus {
		border: 1px solid #2786bf;
		border-radius: 5px;
	}

	&:hover {
		${TrashIconStyled} {
			path {
				fill: ${({ theme: { user } }) => user.removeIconHover};
				stroke: ${({ theme: { user } }) => user.removeIconHover};
			}
		}
	}
`;
